import { IoCalendar, IoList, IoNotifications } from "react-icons/io5";

const sidebarMenu = [
	{
		id: 1,
		path: "/dashboard/calendar",
		name: "Calendar",
		icon: <IoCalendar />,
	},
	{
		id: 2,
		path: "/dashboard/event-list",
		name: "Event List",
		icon: <IoList />,
	},
	{
		id: 3,
		path: "/dashboard/notification",
		name: "Notification",
		icon: <IoNotifications />,
	},
];

export default sidebarMenu;
